import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { serverError } from './../../../../core/models/messages';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, IState, State } from 'country-state-city';
import { translations } from '../../../../core/models/call-offer';
@Component({
  selector: 'app-suggestion-job-offer',
  templateUrl: './suggestion-job-offer.component.html',
  styleUrls: ['./suggestion-job-offer.component.css'],
})
export class SuggestionJobOfferComponent {
  connectedUser = this.localStorageService.getData('userConnected');
  loadSpinner: boolean = false;
  idappel: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listSuggestion: any;
  pagination : boolean =false;

  sortAttr = '';
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  currentSortColumn: string = 'name'; // Initial column to sort by
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList!: IState[];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  selectedUserId!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');
  idclientConnected: any;
  isCollapsed = true;
  iduser: any;
  listconsultant: any;
  consultant_id: any;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  skillsList: { name_FR: string }[] = [];

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private activatedRoute: ActivatedRoute,
    private appelofferservice: EsnAppeloffreService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.countries = Country.getAllCountries();
    this.getId();
    this.getListSuggestionsJobOffer();
    this.getListSkills();
    this.getlistconsultant();
  }
  // sortData(columnName: string) {
  //   let sort={sort:this.currentSortDirection,sortAttribute:this.currentSortColumn}

  //   if (this.currentSortColumn === columnName) {
  //     this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1; // Toggle sort direction
  //   } else {
  //     this.currentSortColumn = columnName; // Change the sort column
  //     this.currentSortDirection = 1; // Reset sort direction to ascending
  //   }
  //   this.getListappeloffre(sort);
  // }
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.consultant_id = params.params['id'];
      },
    });
  }
  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.sortAttr = item;
    this.currentPage = 1;
    this.endIndex = 5;
    // let sort={sort:this.currentSortDirection,sortAttribute:item}
    // console.log("sort",sort)
    if (this.searchForm.value != '')
      this.listSuggestion = this.sortDataService.sortArray(
        this.listSuggestion,
        this.sortAttr,
        this.currentSortDirection
      );
    else this.getListSuggestionsJobOffer();
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchSuggestionJobOffer();
      } else if( (this.startIndex !=0 ||this.endIndex !=5) || this.pagination == true) {
        this.pagination = true
        this.getListSuggestionsJobOffer();
      }
    }
  }

  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('city')?.setValue(null);
    }
  }
  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchSuggestionJobOffer();
  }
  getListSuggestionsJobOffer() {
    let dataPyload =
      this.sortAttr == ''
        ? {
            per_page: this.itemsPerPage,
            page: this.currentPage,
            consultant_id: this.consultant_id,
          }
        : {
            ...{
              per_page: this.itemsPerPage,
              page: this.currentPage,
              consultant_id: this.consultant_id,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.appelofferservice.getListSuggestionJobOffer(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listSuggestion = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
      },
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      // esn_id: ['', data?.esn_id],
      name: ['', data?.name],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      ID_jobRequest: ['', data?.ID_jobRequest],
      experience_range: ['', data?.experience_range],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      client_final_name: ['', data?.client_final_name],
      contract_type: [[], data?.contract_type],
      post_type: [[], data?.post_type],
      years_of_experience: ['', data?.years_of_experience],
      city: [[], data?.city],
      country: [null, data?.country],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      state: [null, data?.state],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  convertKToNumber(value: any) {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
      return parseFloat(value.slice(0, -1)) * 1000;
    } else if (!isNaN(value)) {
      return parseFloat(value) * 1000;
    }
    return parseFloat(value);
  }
  /* search */
  searchSuggestionJobOffer(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let data = {
      name: valueForm.name,
      ID_jobRequest: valueForm.ID_jobRequest,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      client_final_name: valueForm.client_final_name,
      contract_type: valueForm.contract_type,
      post_type: valueForm.post_type,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      city: valueForm.city,
      country: valueForm.country,
      start_date: valueForm.start_date
        ? moment(valueForm.start_date).format('YYYY-MM-DD')
        : '',
      end_date: valueForm.end_date
        ? moment(valueForm.end_date).format('YYYY-MM-DD')
        : '',
      state: valueForm.state,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      search: this.transformSearch(valueForm?.search),
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      per_page: this.itemsPerPage,
      page:pageNumber,
    };

    this.appelofferservice.searchSuggestionJobOffer(data).subscribe({
      next: (resSearch) => {
        if(this.startSearching == true) {
          this.currentPage = 1;
          this.startSearching = false;
        }  
        this.listSuggestion = resSearch.data.data.slice(0, this.endIndex);
        this.totalItems = resSearch.data.total;
      },
      error: (error) => {
        this.toastrService.error(serverError);
      },
    });
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data.items.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  archiverappeloffre(id: any) {
    Swal.fire({
      title: 'Vous êtes sûr d’archiver l’offre sélectionnée ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, archiver !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.appelofferservice
          .archiverappeloffre(id, this.idclientConnected)
          .subscribe({
            next: (response: any) => {
              if (response.data) {
                this.toastrService.success(
                  'L’appel d’offre a été archivé avec succès.'
                );
                this.getListSuggestionsJobOffer();
                // this.route.navigateByUrl("/offres-appel/archived")
                // this.getListjoboffer()
                // this.listjoboffers=response.data.data.slice(0,this.endIndex)
                // this.totalItems = response.data.total;
                // this.spinner.hide()
                // this.loadSpinnerTable=false
                // console.log('list job offer', this.listjoboffers);
              }
            },
            error: (error: any) => {
            },
          });
      }
    });
  }
  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;

      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    }
  }

  open(appel: any) {
    this.idappel = appel.id;
  }
  getlistconsultant() {
    this.appelofferservice.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
      },
      error: (error) => {
      },
    });
  }
  deselectOtherCheckboxes(currentUserId: string) {
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false;
      }
    });
  }

  postuleroffre() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.selectedUserId,
      job_request_id: this.idappel,
    };
    this.appelofferservice.applyJob(data).subscribe({
      next: (res: any) => {
        this.toastrService.success(
          'votre candidature a été envoyé avec succès.'
        );
      },
      error: (error) => {
        if (error.error.message === 'candidature already exist.') {
          this.toastrService.error('Candidature existe déjà');
        }
        if (error.error.message === 'the job offer has been deactivated.') {
          this.toastrService.error(
            "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
          );
        }
      },
    });
  }
}
